import React from 'react';
import Proximamente from '../components/Proximamente';
import Navbar from '../components/Navbar'

const Clima = () => {
    return (
        <div>
            <Navbar />
            <Proximamente />
        </div>
    );
};

export default Clima;